<div class="app-page">
  <div class="app-page-content">
    <section class="app-card">
      <!-- Header -->
      <header class="mb-6">
        <div class="flex items-center gap-3 mb-2">
          <button
            pButton
            type="button"
            icon="pi pi-arrow-left"
            class="p-button-text p-button-sm"
            (click)="onCancel()">
          </button>
          <h1 class="section-title">{{ pageTitle }}</h1>
        </div>
        <p class="section-subtitle">
          {{ isEditMode() ? 'Modifica los datos del tipo de producto' : 'Completa los datos del nuevo tipo de producto' }}
        </p>
      </header>

      <!-- Form -->
      <form [formGroup]="tipoProductoForm" (ngSubmit)="onSubmit()">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <!-- Código -->
          <div class="flex flex-col gap-2">
            <label for="codigo" class="font-medium text-sm">
              Código <span class="text-red-500">*</span>
            </label>
            <input
              id="codigo"
              type="text"
              pInputText
              formControlName="codigo"
              placeholder="Ingrese el código del tipo de producto"
              class="w-full"
              [class.ng-invalid]="tipoProductoForm.get('codigo')?.invalid && tipoProductoForm.get('codigo')?.touched"
            />
            <small
              *ngIf="tipoProductoForm.get('codigo')?.invalid && tipoProductoForm.get('codigo')?.touched"
              class="text-red-500">
              El código es requerido
            </small>
          </div>

          <!-- Nombre -->
          <div class="flex flex-col gap-2">
            <label for="nombre" class="font-medium text-sm">
              Nombre <span class="text-red-500">*</span>
            </label>
            <input
              id="nombre"
              type="text"
              pInputText
              formControlName="nombre"
              placeholder="Ingrese el nombre del tipo de producto"
              class="w-full"
              [class.ng-invalid]="tipoProductoForm.get('nombre')?.invalid && tipoProductoForm.get('nombre')?.touched"
            />
            <small
              *ngIf="tipoProductoForm.get('nombre')?.invalid && tipoProductoForm.get('nombre')?.touched"
              class="text-red-500">
              El nombre es requerido
            </small>
          </div>

          <!-- Canal -->
          <div class="flex flex-col gap-2">
            <label for="canal" class="font-medium text-sm">
              Canal <span class="text-red-500">*</span>
            </label>
            <p-select
              id="canal"
              formControlName="canal"
              [options]="canalOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleccionar canal"
              [appendTo]="'body'"
              class="w-full">
            </p-select>
          </div>

          <!-- Unidad de tarifación -->
          <div class="flex flex-col gap-2">
            <label for="unidadTarifacion" class="font-medium text-sm">
              Unidad de tarifación <span class="text-red-500">*</span>
            </label>
            <p-select
              id="unidadTarifacion"
              formControlName="unidadTarifacion"
              [options]="unidadOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleccionar unidad"
              [appendTo]="'body'"
              class="w-full">
            </p-select>
          </div>
        </div>

        <div class="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div class="app-card border border-border">
            <h2 class="text-sm font-semibold mb-4" style="color: hsl(var(--text));">Flags Aire</h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div class="flex items-center gap-3">
                <p-toggleSwitch id="requierePrograma" formControlName="requierePrograma"></p-toggleSwitch>
                <label for="requierePrograma" class="text-sm text-muted">Requiere programa</label>
              </div>
              <div class="flex items-center gap-3">
                <p-toggleSwitch id="requiereMaterial" formControlName="requiereMaterial"></p-toggleSwitch>
                <label for="requiereMaterial" class="text-sm text-muted">Requiere material</label>
              </div>
              <div class="flex items-center gap-3">
                <p-toggleSwitch id="requiereFranjaHoraria" formControlName="requiereFranjaHoraria"></p-toggleSwitch>
                <label for="requiereFranjaHoraria" class="text-sm text-muted">Requiere franja horaria</label>
              </div>
              <div class="flex items-center gap-3">
                <p-toggleSwitch id="requiereDiaTipo" formControlName="requiereDiaTipo"></p-toggleSwitch>
                <label for="requiereDiaTipo" class="text-sm text-muted">Requiere día grupo</label>
              </div>
            </div>
          </div>

          <div class="app-card border border-border">
            <h2 class="text-sm font-semibold mb-4" style="color: hsl(var(--text));">Flags Digital</h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div class="flex items-center gap-3">
                <p-toggleSwitch id="requiereFormatoDigital" formControlName="requiereFormatoDigital"></p-toggleSwitch>
                <label for="requiereFormatoDigital" class="text-sm text-muted">Requiere formato digital</label>
              </div>
              <div class="flex items-center gap-3">
                <p-toggleSwitch id="requiereUbicacionDigital" formControlName="requiereUbicacionDigital"></p-toggleSwitch>
                <label for="requiereUbicacionDigital" class="text-sm text-muted">Requiere ubicación digital</label>
              </div>
              <div class="flex items-center gap-3">
                <p-toggleSwitch id="permiteBonificacion" formControlName="permiteBonificacion"></p-toggleSwitch>
                <label for="permiteBonificacion" class="text-sm text-muted">Permite bonificación</label>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-6">
          <div class="flex items-center gap-3">
            <p-toggleSwitch id="active" formControlName="active"></p-toggleSwitch>
            <label for="active" class="text-sm text-muted">
              {{ tipoProductoForm.get('active')?.value ? 'Activo' : 'Inactive' }}
            </label>
          </div>
        </div>

        <!-- Botones de acción -->
        <div class="flex items-center gap-3 mt-8 pt-6 border-t border-border">
          <button
            pButton
            type="submit"
            [label]="isEditMode() ? 'Actualizar' : 'Crear'"
            icon="pi pi-check"
            class="p-button-sm"
            [disabled]="loading() || tipoProductoForm.invalid">
          </button>
          <button
            pButton
            type="button"
            label="Cancelar"
            icon="pi pi-times"
            class="p-button-outlined p-button-sm"
            (click)="onCancel()"
            [disabled]="loading()">
          </button>
        </div>
      </form>
    </section>
  </div>
</div>
